import { Theme } from '@radix-ui/themes';
import type { ReactNode } from 'react';

import '@radix-ui/themes/styles.css';
import './radix-overrides.css';

interface FoodyThemeProps {
  children: ReactNode;
}

export function FoodyTheme({ children }: FoodyThemeProps) {
  return (
    <Theme
      accentColor="ruby"
      grayColor="sand"
      radius="medium"
      scaling="100%"
      panelBackground="translucent"
    >
      {children}
    </Theme>
  );
}
